<template>
  <span
    v-b-tooltip
    class="badge badge-light  tag-visualizacao"
    :title="value.valor"
  >
    <strong>{{ value.chave }}:&nbsp;</strong><span>{{ value.valor }}</span>
  </span>
</template>

<style lang="scss">
.tag-visualizacao {
  margin-right: 0.3rem;
  margin-bottom: 0.2rem;
  border: 0.80px solid var(--primary) !important;
  background-color: transparent;
  color: var(--primary) !important;
  font-size: 12px;
  max-width: 10rem;
  padding: 0.2rem 0.2rem !important;
  display: inline-flex;

  span {
    font-weight: 450!important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>

<script>
export default {
  name: 'TagVisualizacao',
  props: {
    value: {
      type: Object,
      default: () => { },
    },
  },
}
</script>
